<template>
  <div :class="['dropdown-menu', ...classes]">
    <a :class="{ active: active }" @click="toggle">{{ title }}</a>
    <div v-if="active" class="dropdown-items-wrapper">
      <template v-for="{ text, link, children, classes } in items">
        <a
          v-if="link"
          :key="text"
          :href="generateLink(link)"
          :class="['dropdown-item', ...classes]"
        >
          {{ text }}
        </a>

        <navigation-dropdown-mobile
          v-if="children"
          :key="text"
          :items="children"
          :title="text"
          :classes="['dropdown-inner']"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { siteLink } from "@/constants/links";

export default {
  name: "NavigationDropdownMobile",
  props: ["title", "items", 'classes'],
  data() {
    return {
      active: false
    };
  },
  computed: {
    getLinkPrefix() {
      return this.$store.state.search.isMobile
        ? siteLink.mobile
        : siteLink.desktop;
    }
  },
  created: function() {
    window.addEventListener("click", this.closeDropdown);
  },
  methods: {
    toggle() {
      this.active = !this.active;
    },
    generateLink(link) {
      if (!link) {
        return "#";
      }

      return this.getLinkPrefix + link;
    },
    closeDropdown(event) {
      if (!this.$el.contains(event.target)) {
        this.active = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.dropdown-menu {
  color: #5d5d5d;
  font-size: 15px;
  font-weight: bold;

  & > a {
    display: block;
    padding: 15px 30px;
    border-bottom: 1px solid #e5e5e5;

    &::after {
      content: "";
      display: inline-block;
      width: 0;
      height: 0;
      margin-left: 4px;
      vertical-align: middle;
      border-top: 4px dashed;
      border-top: 4px solid;
      border-right: 4px solid transparent;
      border-left: 4px solid transparent;
    }

    &.active {
      color: #002c5f;
    }
  }

  .dropdown-item {
    padding: 15px 30px 15px 65px;
    border-bottom: 1px solid #e5e5e5;

    &:last-of-type {
      border-bottom: none;
    }

    &.green-ireland {
      color: limegreen;

      &::before {
        content: "";
        background-image: url("https://www.hyundai.ie/greener-ireland/img/hyundai-leaf.png");
        vertical-align: middle;
        width: 20px;
        height: 20px;
        display: inline-block;
      }
    }
  }

  .dropdown-inner {
    a {
      padding-left: 65px;
      border-bottom: 1px solid #e5e5e5 !important;
    }
  }

  .dropdown-items-wrapper {
    display: flex;
    flex-direction: column;
  }
}
</style>
